import React, { memo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoadingFallback from "../components/elements/LoadingFallback";
import { useSelector } from "react-redux";

const UserRoute = memo(function UserRoute({ children }) {
  const navigate = useNavigate();
  const { session } = useSelector((state) => state?.authProvider);

  useEffect(() => {
    if (session?.status === "unauthorized") {
      navigate("/authentication");
    } else if (session?.status === "authorized" && session?.user?.roleCode === "admin") {
      navigate("/admin/dashboard");
    } else if (session?.status === "authorized" && session?.user?.roleCode === "donor") {
      navigate("/donor/donation");
    }
  }, [session?.status, session?.user?.roleCode, navigate]);

  if (session?.status === "loading") {
    return <LoadingFallback />;
  }

  return session?.status === "authorized" && session?.user?.roleCode === "user" ? children : null;
});

export default UserRoute;
